import Vue from 'vue';
import i18n from '../../i18n';

export default new Vue({
  data() {
    return {
      isFullScreen: false,
      skuLegends: [
        {
          name: 'Out Of Stock',
          mobileName: 'OOS',
          id: 'out_of_stock',
          color: '#ff4444',
          line_color: 0xff4444,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Missing'),
          id: 'missing',
          color: '#f9cb49',
          line_color: 0xf9cb49,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Misplaced'),
          id: 'misplaced',
          color: '#6efff1',
          line_color: 0x6efff1,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Excess'),
          id: 'excess',
          color: '#76ff5f',
          line_color: 0x76ff5f,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Unrecognized'),
          id: 'unrecognized',
          color: '#777777',
          line_color: 0x777777,
          isChecked: true,
          show: false
        }
      ],
      selectClass: [
        {
          name: i18n.t('My Sku'),
          id: 'sku',
          color: '#f9cb49',
          line_color: 0xfcee22,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Competitor Sku'),
          id: 'competitor_sku',
          color: '#c729ff',
          line_color: 0xc729ff,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Price Tag'),
          id: 'price_tag',
          color: '#6efff1',
          line_color: 0x6efff1,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Other Classes'),
          id: 'other_classes',
          color: '#8cc1ff',
          line_color: 0x8cc1ff,
          isChecked: true,
          show: false
        },
        {
          name: i18n.t('Unrecognized'),
          id: 'unrecognized',
          color: '#777777',
          line_color: 0x777777,
          isChecked: true,
          show: false
        }
      ]
    };
  }
});
